(() => {
 'use strict';
 const behavior = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
 function init(root = document) {
  root.querySelectorAll('[data-carousel]').forEach(carousel => {
   if(carousel.dataset.initialized) return;
   carousel.dataset.initialized='true';
   const track=carousel.querySelector('[data-carousel-track]'); if(!track) return;
   const dots=[...carousel.querySelectorAll('[data-carousel-to]')];
   const progress=carousel.querySelector('[data-carousel-progress]');
   const update=()=>{
    if(dots.length){const index=Math.round(track.scrollLeft/track.clientWidth);dots.forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===index)));}
    if(progress){
     const max=Math.max(0,track.scrollWidth-track.clientWidth),visible=Math.min(1,track.clientWidth/track.scrollWidth);
     progress.style.width=`${visible*100}%`;
     progress.style.marginLeft=`${max ? (track.scrollLeft/max)*(1-visible)*100 : 0}%`;
     carousel.querySelector('[data-carousel-step="-1"]').disabled=track.scrollLeft<2;
     carousel.querySelector('[data-carousel-step="1"]').disabled=track.scrollLeft>=max-2;
     carousel.querySelector('.ritual-row-controls').hidden=max<2;
    }
   };
   const go=(index)=>{const child=track.children[index];if(child)track.scrollTo({left:child.offsetLeft-track.children[0].offsetLeft,behavior:behavior()});};
   carousel.addEventListener('click',event=>{
    const dot=event.target.closest('[data-carousel-to]');if(dot){go(Number(dot.dataset.carouselTo));return;}
    const step=event.target.closest('[data-carousel-step]');if(!step)return;
    if(dots.length){const index=Math.round(track.scrollLeft/track.clientWidth);go((index+Number(step.dataset.carouselStep)+dots.length)%dots.length);}
    else track.scrollBy({left:Number(step.dataset.carouselStep)*track.clientWidth*.9,behavior:behavior()});
   });
   track.addEventListener('scroll',update, {passive:true});
   if(window.ResizeObserver){const observer=new ResizeObserver(update);observer.observe(track);carousel._ritualObserver=observer;}
   update();
  });
  root.querySelectorAll('[data-product-carousel]').forEach(carousel=>{
   if(carousel.dataset.initialized)return;carousel.dataset.initialized='true';const track=carousel.querySelector('[data-product-gallery]');
   carousel.addEventListener('click',event=>{const button=event.target.closest('[data-media-step]');if(!button)return;const index=Math.round(track.scrollLeft/track.clientWidth);const next=(index+Number(button.dataset.mediaStep)+track.children.length)%track.children.length;track.scrollTo({left:next*track.clientWidth,behavior:behavior()});});
   track.addEventListener('scroll',()=>{carousel.querySelector('[data-media-current]').textContent=Math.round(track.scrollLeft/track.clientWidth)+1;},{passive:true});
  });
 }
 document.addEventListener('click',event=>{
  document.querySelectorAll('.ritual-nav-dropdown[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;});
 });
 document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.ritual-nav-dropdown[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});
 document.addEventListener('toggle',event=>{if(event.target.matches('.ritual-nav-dropdown[open]'))document.querySelectorAll('.ritual-nav-dropdown[open]').forEach(other=>{if(other!==event.target&&!other.contains(event.target))other.open=false;});},true);
 document.addEventListener('shopify:section:load',event=>init(event.target));
 document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-carousel]').forEach(carousel=>carousel._ritualObserver?.disconnect()));
 init();
})();
